module.exports = __webpack_public_path__ + "img/vite.9bf3a2a8.svg";